// extracted by mini-css-extract-plugin
export var orderDetails = "_qz-2";
export var orderImage = "_qz-1";
export var orderMeta = "_qz-3";
export var orderSummary = "_qz-0";
export var rightArrow = "_qz-4";